import {t} from 'ttag';

export const toNull = c => !c ? null : c;

const useMyTripFormValidation = (validatorOverride = {}) => {

    const validator = {
        pnr: ({pnr: s}) => toNull(!(s && /^([a-zA-Z0-9]{6})$/g.test(s))) && [t`Invalid booking code`],
        lastName: ({lastName: s}) => toNull(!(s && /^.+$/g.test(s))) && [t`Invalid last name`],
        ...validatorOverride
    };

    const isFormDataValid = (formData = {}, formDataValidator = {}) => {
        const dataValidator = {...validator, ...formDataValidator};
        return Object.entries(dataValidator).every(([validatorName, validator]) => {
            return typeof validator === 'function' ? !validator(formData, dataValidator) : !validator;
        });
    };

    return {validator, isFormDataValid};
};

export default useMyTripFormValidation;